import * as actions from './actions';
import sendGoogleAnalyticsEvent from '../../utils/tracking/googleAnalytics';
import * as googleAnalyticsEvents from '../../utils/tracking/googleAnalytics';
import { getActionCompletedTime } from '../../utils/actionTiming';
import { appendTrackingPixels } from '../../utils/thirdPartyTracking/helpers';

const eventMappings = {};
eventMappings[actions.EMAIL_SUCCESS] = [trackCompleteAction];

export default function trackEmail(type, state) {
    const eventTrackers = eventMappings[type];
    if (eventTrackers != null) {
        eventTrackers.map(f => f(state));
    }
}

function trackCompleteAction(state) {
    sendGoogleAnalyticsEvent(googleAnalyticsEvents.EVENT_ACTION_COMPLETED, {
        ...state.widget,
        action: state.widget.activeAction,
        actionCompleteTime: getActionCompletedTime(state)()
    });

    if (state.widget.isEmailSubmitted) appendTrackingPixels('emailCompletion', state);
}
